import { ClassroomRepository } from '@xq/infrastructure';

export class AssignProgramUseCase {
  static async execute(classroomIds: string[], programId: string) {
    const classroomRepository = new ClassroomRepository();

    return classroomRepository.assignProgram(classroomIds, programId);
  }
}
